import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, VersionColumn } from 'typeorm';

@Entity('apa_size_matrix')
export class ApaSizeMatrixEntity {
  @PrimaryGeneratedColumn({ type: 'int', name: 'Id' })
  id: number;

  @Column('varchar', { name: 'buy_month', length: 50, nullable: true })
  buyMonth: string;

  @Column('varchar', { name: 'fd_of', length: 50, nullable: true })
  fdOf: string;

  @Column('varchar', { name: 'style_number', length: 50, nullable: true })
  styleNumber: string;

  @Column('varchar', { name: 'style_type', length: 50, nullable: true })
  styleType: string;

  @Column('varchar', { name: 'usa_size', length: 255, nullable: true })
  usaSize: string;

  @Column('varchar', { name: 'china_size_matrixtype', length: 255, nullable: true })
  chinaSizeMatrixtype: string;

  @Column('varchar', { name: 'china_top_size', length: 255, nullable: true })
  chinaTopSize: string;

  @Column('varchar', { name: 'china_top_bodysize', length: 255, nullable: true })
  chinaTopBodysize: string;

  @Column('varchar', { name: 'china_bottom_size', length: 255, nullable: true })
  chinaBottomSize: string;

  @Column('varchar', { name: 'china_bottom_bodysize', length: 255, nullable: true })
  chinaBottomBodysize: string;

  @Column('varchar', { name: 'korea_size_matrixtype', length: 255, nullable: true })
  koreaSizeMatrixtype: string;

  @Column('varchar', { name: 'korea_top_generic', length: 255, nullable: true })
  koreaTopGeneric: string;

  @Column('varchar', { name: 'korea_top_chest', length: 255, nullable: true })
  koreaTopChest: string;

  @Column('varchar', { name: 'korea_top_height', length: 255, nullable: true })
  koreaTopHeight: string;

  @Column('varchar', { name: 'korea_bottom_generic', length: 255, nullable: true })
  koreaBottomGeneric: string;

  @Column('varchar', { name: 'korea_bottom_waist', length: 255, nullable: true })
  koreaBottomWaist: string;

  @Column('varchar', { name: 'korea_bottom_hip', length: 255, nullable: true })
  koreaBottomHip: string;

  @Column('varchar', { name: 'korea_age', length: 255, nullable: true })
  koreaAge: string;

  @Column('varchar', { name: 'fty_shk', length: 255, nullable: true })
  ftyShk: string;

  @Column('varchar', { name: 'created_user', length: 50, nullable: true })
  createdUser: string;

  @UpdateDateColumn({ type: 'datetime', precision: 6, name: 'updated_at', default: () => 'CURRENT_TIMESTAMP(6)' })
  updatedAt: Date;

  @Column('varchar', { name: 'updated_user', length: 50, nullable: true })
  updatedUser: string;

  @VersionColumn({ type: 'int', name: 'version_flag', default: 1 })
  versionFlag: number;

  @Column('tinyint', { name: 'is_active', width: 4, default: 1 })
  isActive: boolean;
  
  @UpdateDateColumn({ type: 'datetime', precision: 6, name: 'created_at', default: () => 'CURRENT_TIMESTAMP(6)' })
  createdAt: Date;
}
